export default {
  title: 'Personal Information',
  warningLabel: 'Please note',
  successLabel: 'Your changes will be effective within 48 hours for these contracts:',
  successLabelNoContracts: 'Your changes will be effective within 48 hours.',
  closeButton: 'Return',
};
